export interface Logger {
  debug: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
}

export function createLogger(enabled: boolean): Logger {
  const noop = () => undefined;

  return {
    debug: enabled ? (...args) => console.debug("[go-offline]", ...args) : noop,
    info: (...args) => console.info("[go-offline]", ...args),
    warn: (...args) => console.warn("[go-offline]", ...args),
    error: (...args) => console.error("[go-offline]", ...args)
  };
}
